import { render, staticRenderFns } from "./chat-room.vue?vue&type=template&id=0533ae04&scoped=true"
import script from "./chat-room.vue?vue&type=script&lang=js"
export * from "./chat-room.vue?vue&type=script&lang=js"
import style0 from "./chat-room.vue?vue&type=style&index=0&id=0533ae04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533ae04",
  null
  
)

export default component.exports